import { sendTracking } from '@helpers/tracking';

const faiTracking = {
    universe: 'Boutique_fai',
    marketLine: 'Fai',
};

export function sendHomePageTracking(
    defaultTab = window.location.hash?.replace('#', ''),
    isNewFaiCategories: boolean = false,
) {
    sendTracking(false, {
        page: 'Home_fai',
        category: 'Eligibilite',
        pageCategory: 'Liste_produits_fai',
        eCommerceStep: 'Liste_produits',
        variant: {
            onglet: defaultTab ?? '',
            etape_eligibilite: 'Eligibilite_accueil',
            abtest: isNewFaiCategories.toString(),
        },
        ...faiTracking,
    });
}

export function sendPromoConfiguratorTracking(checked: boolean) {
    sendTracking(false, {
        action: 'Clic_affichage',
        category: 'Toggle_prix_big',
        name: `${checked ? 'Selection' : 'Deselection'}_voir_prix_avec_forfait_mobile`,
    });
}
